import React, { useState } from "react";
import "./Styling.css";
import { loginToCMO } from "../../services/dataAnalyticsApi";
import { useNavigate } from "react-router-dom";
import eyeOpen from "./images/eyeOpen.png";
import eyeClose from "./images/eyeClose.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const result = await loginToCMO(username, password);

      if (result.status === "Authenticated") {
        localStorage.setItem("user_name", username);
        navigate("/dataAnalytics");
      } else {
        // Show error message from API
        setError(result.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="login-container">   
      <div className="login-box">
        <h2 className="login-title">Login</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <label>Username</label>
          <div className="input-group">
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <label>Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
              style={{ cursor: "pointer", marginLeft: "8px" }}
              title={showPassword ? "Hide password" : "Show password"}
            >
              <img
                src={showPassword ? eyeClose : eyeOpen}
                alt="Toggle password visibility"
                width="15"
                height="15"
              />
            </span>
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
